
import { dataFetcher } from 'core/services/requestHandler';   

const getInfo = async (data = {}, config = {}) => {
  return dataFetcher('wesecure/info', data, {...config});
};

const getTransactions = async (data = {}, config = {}) => {
  return dataFetcher('wesecure/transactions', data, {...config});
};

const initPayment = async (data = {}, config = {}) => {
  return dataFetcher('wesecure/initiatePayment', data, {method: 'POST', ...config});
};


export { getInfo, getTransactions, initPayment };
